const SCHOOLS_BY_NAME_MD_RESPONSE = [
  {
    COMBOKEY: '341134002244',
    LEA_NAME: 'NEWARK PUBLIC SCHOOL DISTRICT',
    LEA_STATE: 'NJ',
    RR_AM_F_WH_F_MD: null,
    RR_AM_M_POP_MD: 0,
    RR_AM_M_WH_M_MD: null,
    RR_AS_F_POP_MD: 0,
    RR_AS_F_WH_F_MD: null,
    RR_AS_M_POP_MD: 0,
    RR_AS_M_WH_M_MD: null,
    RR_BL_F_POP_MD: 4.067307692,
    RR_BL_F_WH_F_MD: null,
    RR_BL_M_POP_MD: 0,
    RR_BL_M_WH_M_MD: null,
    RR_HI_F_POP_MD: 1.188571429,
    RR_HI_F_WH_F_MD: null,
    RR_HI_M_POP_MD: 0.847926267,
    RR_HI_M_WH_M_MD: null,
    RR_HP_F_POP_MD: null,
    RR_HP_F_WH_F_MD: null,
    RR_HP_M_POP_MD: 0,
    RR_HP_M_WH_M_MD: null,
    RR_TR_F_POP_MD: null,
    RR_TR_F_WH_F_MD: null,
    RR_TR_M_POP_MD: null,
    RR_TR_M_WH_M_MD: null,
    RR_WH_F_POP_MD: 0,
    RR_WH_M_POP_MD: 0,
    SCHOOL_NAME: 'BRANCH BROOK SCHOOL',
    __typename: 'Multipledisability',
  },
  {
    COMBOKEY: '240042001172',
    LEA_NAME: 'Howard County Public Schools',
    LEA_STATE: 'MD',
    RR_AM_F_WH_F_MD: null,
    RR_AM_M_POP_MD: 0,
    RR_AM_M_WH_M_MD: 0,
    RR_AS_F_POP_MD: 0,
    RR_AS_F_WH_F_MD: null,
    RR_AS_M_POP_MD: 0,
    RR_AS_M_WH_M_MD: 0,
    RR_BL_F_POP_MD: 0,
    RR_BL_F_WH_F_MD: null,
    RR_BL_M_POP_MD: 0,
    RR_BL_M_WH_M_MD: 0,
    RR_HI_F_POP_MD: 0,
    RR_HI_F_WH_F_MD: null,
    RR_HI_M_POP_MD: 0,
    RR_HI_M_WH_M_MD: 0,
    RR_HP_F_POP_MD: null,
    RR_HP_F_WH_F_MD: null,
    RR_HP_M_POP_MD: 0,
    RR_HP_M_WH_M_MD: 0,
    RR_TR_F_POP_MD: 0,
    RR_TR_F_WH_F_MD: null,
    RR_TR_M_POP_MD: 0,
    RR_TR_M_WH_M_MD: 0,
    RR_WH_F_POP_MD: 0,
    RR_WH_M_POP_MD: null,
    SCHOOL_NAME: 'Bonnie Branch Middle',
    __typename: 'Multipledisability',
  },
  {
    COMBOKEY: '510252000178',
    LEA_NAME: 'MONTGOMERY CO PBLC SCHS',
    LEA_STATE: 'VA',
    RR_AM_F_WH_F_MD: null,
    RR_AM_M_POP_MD: null,
    RR_AM_M_WH_M_MD: null,
    RR_AS_F_POP_MD: 0,
    RR_AS_F_WH_F_MD: null,
    RR_AS_M_POP_MD: 0,
    RR_AS_M_WH_M_MD: 0,
    RR_BL_F_POP_MD: 0,
    RR_BL_F_WH_F_MD: null,
    RR_BL_M_POP_MD: 50.8,
    RR_BL_M_WH_M_MD: 22,
    RR_HI_F_POP_MD: 0,
    RR_HI_F_WH_F_MD: null,
    RR_HI_M_POP_MD: 0,
    RR_HI_M_WH_M_MD: 0,
    RR_HP_F_POP_MD: null,
    RR_HP_F_WH_F_MD: null,
    RR_HP_M_POP_MD: null,
    RR_HP_M_WH_M_MD: null,
    RR_TR_F_POP_MD: 0,
    RR_TR_F_WH_F_MD: null,
    RR_TR_M_POP_MD: 0,
    RR_TR_M_WH_M_MD: 0,
    RR_WH_F_POP_MD: 0,
    RR_WH_M_POP_MD: 0.7,
    SCHOOL_NAME: 'Falling Branch Elementary',
    __typename: 'Multipledisability',
  },
  {
    COMBOKEY: '181035002230',
    LEA_NAME: 'South Gibson School Corporation',
    LEA_STATE: 'IN',
    RR_AM_F_WH_F_MD: null,
    RR_AM_M_POP_MD: 0,
    RR_AM_M_WH_M_MD: 0,
    RR_AS_F_POP_MD: 0,
    RR_AS_F_WH_F_MD: null,
    RR_AS_M_POP_MD: 0,
    RR_AS_M_WH_M_MD: 0,
    RR_BL_F_POP_MD: null,
    RR_BL_F_WH_F_MD: null,
    RR_BL_M_POP_MD: 0,
    RR_BL_M_WH_M_MD: 0,
    RR_HI_F_POP_MD: 0,
    RR_HI_F_WH_F_MD: null,
    RR_HI_M_POP_MD: 0,
    RR_HI_M_WH_M_MD: 0,
    RR_HP_F_POP_MD: null,
    RR_HP_F_WH_F_MD: null,
    RR_HP_M_POP_MD: null,
    RR_HP_M_WH_M_MD: null,
    RR_TR_F_POP_MD: 0,
    RR_TR_F_WH_F_MD: null,
    RR_TR_M_POP_MD: 0,
    RR_TR_M_WH_M_MD: 0,
    RR_WH_F_POP_MD: 0,
    RR_WH_M_POP_MD: null,
    SCHOOL_NAME: 'Fort Branch Community School',
    __typename: 'Multipledisability',
  },
  {
    COMBOKEY: '210240000497',
    LEA_NAME: 'Greenup County',
    LEA_STATE: 'KY',
    RR_AM_F_WH_F_MD: 0,
    RR_AM_M_POP_MD: null,
    RR_AM_M_WH_M_MD: null,
    RR_AS_F_POP_MD: null,
    RR_AS_F_WH_F_MD: null,
    RR_AS_M_POP_MD: 0,
    RR_AS_M_WH_M_MD: null,
    RR_BL_F_POP_MD: 0,
    RR_BL_F_WH_F_MD: 0,
    RR_BL_M_POP_MD: 0,
    RR_BL_M_WH_M_MD: null,
    RR_HI_F_POP_MD: 0,
    RR_HI_F_WH_F_MD: 0,
    RR_HI_M_POP_MD: null,
    RR_HI_M_WH_M_MD: null,
    RR_HP_F_POP_MD: null,
    RR_HP_F_WH_F_MD: null,
    RR_HP_M_POP_MD: null,
    RR_HP_M_WH_M_MD: null,
    RR_TR_F_POP_MD: 0,
    RR_TR_F_WH_F_MD: 0,
    RR_TR_M_POP_MD: 0,
    RR_TR_M_WH_M_MD: null,
    RR_WH_F_POP_MD: null,
    RR_WH_M_POP_MD: 0,
    SCHOOL_NAME: 'Greysbranch Elementary School',
    __typename: 'Multipledisability',
  },
  {
    COMBOKEY: '510027000100',
    LEA_NAME: 'ARLINGTON CO PBLC SCHS',
    LEA_STATE: 'VA',
    RR_AM_F_WH_F_MD: null,
    RR_AM_M_POP_MD: 0,
    RR_AM_M_WH_M_MD: 0,
    RR_AS_F_POP_MD: 0,
    RR_AS_F_WH_F_MD: null,
    RR_AS_M_POP_MD: 0,
    RR_AS_M_WH_M_MD: 0,
    RR_BL_F_POP_MD: 0,
    RR_BL_F_WH_F_MD: null,
    RR_BL_M_POP_MD: 0,
    RR_BL_M_WH_M_MD: 0,
    RR_HI_F_POP_MD: 0,
    RR_HI_F_WH_F_MD: null,
    RR_HI_M_POP_MD: 0,
    RR_HI_M_WH_M_MD: 0,
    RR_HP_F_POP_MD: null,
    RR_HP_F_WH_F_MD: null,
    RR_HP_M_POP_MD: null,
    RR_HP_M_WH_M_MD: null,
    RR_TR_F_POP_MD: 0,
    RR_TR_F_WH_F_MD: null,
    RR_TR_M_POP_MD: 0,
    RR_TR_M_WH_M_MD: 0,
    RR_WH_F_POP_MD: 0,
    RR_WH_M_POP_MD: null,
    SCHOOL_NAME: 'Long Branch Elementary',
    __typename: 'Multipledisability',
  },
  {
    COMBOKEY: '340894003904',
    LEA_NAME: 'LONG BRANCH PUBLIC SCHOOL District',
    LEA_STATE: 'NJ',
    RR_AM_F_WH_F_MD: null,
    RR_AM_M_POP_MD: 0,
    RR_AM_M_WH_M_MD: null,
    RR_AS_F_POP_MD: 0,
    RR_AS_F_WH_F_MD: null,
    RR_AS_M_POP_MD: 0,
    RR_AS_M_WH_M_MD: null,
    RR_BL_F_POP_MD: 0,
    RR_BL_F_WH_F_MD: null,
    RR_BL_M_POP_MD: 0,
    RR_BL_M_WH_M_MD: null,
    RR_HI_F_POP_MD: null,
    RR_HI_F_WH_F_MD: null,
    RR_HI_M_POP_MD: 0,
    RR_HI_M_WH_M_MD: null,
    RR_HP_F_POP_MD: null,
    RR_HP_F_WH_F_MD: null,
    RR_HP_M_POP_MD: null,
    RR_HP_M_WH_M_MD: null,
    RR_TR_F_POP_MD: 0,
    RR_TR_F_WH_F_MD: null,
    RR_TR_M_POP_MD: 0,
    RR_TR_M_WH_M_MD: null,
    RR_WH_F_POP_MD: 0,
    RR_WH_M_POP_MD: 0,
    SCHOOL_NAME: 'Long Branch High School',
    __typename: 'Multipledisability',
  },
  {
    COMBOKEY: '340894003906',
    LEA_NAME: 'LONG BRANCH PUBLIC SCHOOL District',
    LEA_STATE: 'NJ',
    RR_AM_F_WH_F_MD: null,
    RR_AM_M_POP_MD: 0,
    RR_AM_M_WH_M_MD: null,
    RR_AS_F_POP_MD: 0,
    RR_AS_F_WH_F_MD: null,
    RR_AS_M_POP_MD: 0,
    RR_AS_M_WH_M_MD: null,
    RR_BL_F_POP_MD: null,
    RR_BL_F_WH_F_MD: null,
    RR_BL_M_POP_MD: 0,
    RR_BL_M_WH_M_MD: null,
    RR_HI_F_POP_MD: 0,
    RR_HI_F_WH_F_MD: null,
    RR_HI_M_POP_MD: 0,
    RR_HI_M_WH_M_MD: null,
    RR_HP_F_POP_MD: null,
    RR_HP_F_WH_F_MD: null,
    RR_HP_M_POP_MD: null,
    RR_HP_M_WH_M_MD: null,
    RR_TR_F_POP_MD: 0,
    RR_TR_F_WH_F_MD: null,
    RR_TR_M_POP_MD: 0,
    RR_TR_M_WH_M_MD: null,
    RR_WH_F_POP_MD: 0,
    RR_WH_M_POP_MD: 0,
    SCHOOL_NAME: 'Long Branch Middle School',
    __typename: 'Multipledisability',
  },
  {
    COMBOKEY: '210051002245',
    LEA_NAME: 'Boone County',
    LEA_STATE: 'KY',
    RR_AM_F_WH_F_MD: null,
    RR_AM_M_POP_MD: null,
    RR_AM_M_WH_M_MD: null,
    RR_AS_F_POP_MD: 0,
    RR_AS_F_WH_F_MD: 0,
    RR_AS_M_POP_MD: 0,
    RR_AS_M_WH_M_MD: null,
    RR_BL_F_POP_MD: 0,
    RR_BL_F_WH_F_MD: 0,
    RR_BL_M_POP_MD: 0,
    RR_BL_M_WH_M_MD: null,
    RR_HI_F_POP_MD: 0,
    RR_HI_F_WH_F_MD: 0,
    RR_HI_M_POP_MD: 0,
    RR_HI_M_WH_M_MD: null,
    RR_HP_F_POP_MD: 0,
    RR_HP_F_WH_F_MD: 0,
    RR_HP_M_POP_MD: null,
    RR_HP_M_WH_M_MD: null,
    RR_TR_F_POP_MD: 0,
    RR_TR_F_WH_F_MD: 0,
    RR_TR_M_POP_MD: 45.70588235,
    RR_TR_M_WH_M_MD: null,
    RR_WH_F_POP_MD: 1.294797688,
    RR_WH_M_POP_MD: 0,
    SCHOOL_NAME: 'Longbranch Elementary School',
    __typename: 'Multipledisability',
  },
  {
    COMBOKEY: '390499305342',
    LEA_NAME: 'Plain Local',
    LEA_STATE: 'OH',
    RR_AM_F_WH_F_MD: 0,
    RR_AM_M_POP_MD: null,
    RR_AM_M_WH_M_MD: null,
    RR_AS_F_POP_MD: 0,
    RR_AS_F_WH_F_MD: 0,
    RR_AS_M_POP_MD: 0,
    RR_AS_M_WH_M_MD: null,
    RR_BL_F_POP_MD: 0,
    RR_BL_F_WH_F_MD: 0,
    RR_BL_M_POP_MD: 0,
    RR_BL_M_WH_M_MD: null,
    RR_HI_F_POP_MD: 0,
    RR_HI_F_WH_F_MD: 0,
    RR_HI_M_POP_MD: 0,
    RR_HI_M_WH_M_MD: null,
    RR_HP_F_POP_MD: null,
    RR_HP_F_WH_F_MD: null,
    RR_HP_M_POP_MD: null,
    RR_HP_M_WH_M_MD: null,
    RR_TR_F_POP_MD: 0,
    RR_TR_F_WH_F_MD: 0,
    RR_TR_M_POP_MD: 0,
    RR_TR_M_WH_M_MD: null,
    RR_WH_F_POP_MD: null,
    RR_WH_M_POP_MD: 0,
    SCHOOL_NAME: 'Middlebranch Elementary School',
    __typename: 'Multipledisability',
  },
];

export default SCHOOLS_BY_NAME_MD_RESPONSE;
